import * as Yup from "yup";

const classificacaoFinanceiraValidator = Yup.object().shape({
  ativado: Yup.boolean().nullable(),
  nome: Yup.string().required("Nome"),
  tipo: Yup.string().required("Tipo"),
});

export default classificacaoFinanceiraValidator;
